import { createRouter, createWebHistory } from "vue-router";
import { ROLES, SUBSCRIPTION_STATUS } from '@/constantes';
import { getMenuPorUsuario } from './utils/permisos';

import AuthView from "./views/AuthView.vue";
import Perfil from "./views/Perfil.vue";
import Dashboard from "./views/DashBoard.vue";
import Administrador from "./views/Administrador.vue";
import Cotizaciones from "./views/Cotizaciones.vue";
import Ferreteria from "./views/Ferreteria.vue";
import Prospectos from "./views/Prospectos.vue";
import Proveedores from "./views/Proveedores.vue";
import Configuraciones from "./views/Configuraciones.vue";
import CompraMembresia from "./views/CompraMembresia.vue";
import ConfirmarMembresia from "./views/ConfirmarMembresia.vue";
import ErrorCompraMembresia from "./views/ErrorCompraMembresia.vue";
import Instaladores from "./views/Instaladores.vue";
import Bienvenida from "./views/Bienvenida.vue";
import ConfigProveedores from "./views/ConfigProveedores.vue";
import SitioCerrado from "./views/SitioCerrado.vue";
import LandingPage from "./views/LandingPage.vue";
import RestablecerContraseña from "@/components/auth/RestablecerContraseña.vue";

const routes = [
    { path: "/", name: "LandingPage", component: LandingPage, meta: { requiresAuth: false } },
    { path: "/login", name: "AuthView", component: AuthView, meta: { requiresAuth: false } },
    { path: "/restablecer-password/:uid/:token", name: "RestablecerContraseña", component: RestablecerContraseña, meta: { requiresAuth: false }},
    { path: "/Dashboard", name: "Dashboard", component: Dashboard, meta: { requiresAuth: true } },
    { path: "/Perfil", name: "Perfil", component: Perfil, meta: { requiresAuth: true } },
    { path: "/Cotizaciones", name: "Cotizaciones", component: Cotizaciones, meta: { requiresAuth: true } },
    { path: "/Administrador", name: "Administrador", component: Administrador, meta: { requiresAuth: true } },
    { path: "/Instaladores", name: "Instaladores", component: Instaladores, meta: { requiresAuth: true } },
    { path: "/Ferreteria", name: "Ferreteria", component: Ferreteria, meta: { requiresAuth: true } },
    { path: "/Prospectos", name: "Prospectos", component: Prospectos, meta: { requiresAuth: true } },
    { path: "/Proveedores", name: "Proveedores", component: Proveedores, meta: { requiresAuth: true } },
    { path: "/Configuraciones", name: "Configuraciones", component: Configuraciones, meta: { requiresAuth: true } },
    { path: "/CompraMembresia", name: "CompraMembresia", component: CompraMembresia, meta: { requiresAuth: true } },
    { path: "/ConfirmarMembresia", name: "ConfirmarMembresia", component: ConfirmarMembresia, meta: { requiresAuth: true } },
    { path: "/ErrorCompraMembresia", name: "ErrorCompraMembresia", component: ErrorCompraMembresia, meta: { requiresAuth: true } },
    { path: "/Bienvenida", name: "Bienvenida", component: Bienvenida, meta: { requiresAuth: true } },
    { path: "/ConfigProveedores", name: "ConfigProveedores", component: ConfigProveedores, meta: { requiresAuth: true } },
    { path: "/SitioCerrado", name: "SitioCerrado", component: SitioCerrado, meta: { requiresAuth: true } },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return false;
    },
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const userDataString = localStorage.getItem('userData');
    const isAuthenticated = !!userDataString;
    let user = null;
    if (isAuthenticated) {
        try {
            user = JSON.parse(userDataString);
        } catch (e) {
            localStorage.removeItem('userData');
            return next('/'); 
        }
    }

    if (requiresAuth && !isAuthenticated) {
        return next('/');
    }

    if (isAuthenticated) {
        if (to.path === '/' || to.path === '/login') {
            return next('/Bienvenida');
        }
    }

    if (isAuthenticated && user) {

        const idRol = user.rol?.id_rol || user.id_rol;
        const statusSuscripcion = user.suscripcion?.status;

        const esInstalador = idRol === ROLES.INSTALADOR;
        const estaInactivo = statusSuscripcion === SUBSCRIPTION_STATUS.INACTIVE;

        const estaBloqueado = esInstalador && estaInactivo;

        if (estaBloqueado) {
            const rutasPago = ['/CompraMembresia', '/ConfirmarMembresia', '/ErrorCompraMembresia'];

            const esRutaPago = rutasPago.includes(to.path);
            const esRutaPerfil = to.path.startsWith('/Perfil'); 
            if (!esRutaPago && !esRutaPerfil) {
                return next('/CompraMembresia');
            }
        }

        else {
            if (to.path === '/CompraMembresia') {
                return next('/Dashboard');
            }

            const menuOpciones = getMenuPorUsuario(user);

            const rutasComunes = [
                '/Bienvenida',
                '/Perfil',
                '/ConfirmarMembresia',
                '/ErrorCompraMembresia',
            ];

            const tienePermisoMenu = menuOpciones.some(opcion => to.path.startsWith(opcion.ruta));
            const esRutaComun = rutasComunes.some(ruta => to.path.startsWith(ruta));

            if (!tienePermisoMenu && !esRutaComun) {
                console.warn(`Acceso denegado a ${to.path} para rol ${idRol}`);
                return next('/Bienvenida');
            }
        }
    }

    next();
});

export default router;